import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f372901a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-workouts-chart" }
const _hoisted_2 = { class: "workouts-count" }
const _hoisted_3 = {
  key: 0,
  class: "workouts-pane"
}
const _hoisted_4 = { class: "more-workouts" }

import { ref, toRefs } from 'vue'

  import CalendarWorkout from '@/components/Dashboard/UserCalendar/CalendarWorkout.vue'
  import DonutChart from '@/components/Dashboard/UserCalendar/DonutChart.vue'
  import { ISport } from '@/types/sports'
  import { IWorkout } from '@/types/workouts'
  import { getSportLabel } from '@/utils/sports'

  interface Props {
    colors: Record<number, string>
    datasets: Record<number, Record<string, number>>
    sports: ISport[]
    workouts: IWorkout[]
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    colors: null,
    datasets: null,
    sports: null,
    workouts: null
  },
  setup(__props: any) {

const props = __props as {
    colors: Record<number, string>
    datasets: Record<number, Record<string, number>>
    sports: ISport[]
    workouts: IWorkout[]
  }

  

  const { colors, datasets, sports, workouts } = toRefs(props)
  const isHidden = ref(true)

  function togglePane(event: Event & { target: HTMLElement }) {
    event.stopPropagation()
    isHidden.value = !isHidden.value
  }

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "workouts-chart",
      onClick: togglePane
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(workouts).length), 1),
      _createVNode(DonutChart, {
        datasets: _unref(datasets),
        colors: _unref(colors)
      }, null, 8, ["datasets", "colors"])
    ]),
    (!isHidden.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", {
              class: "fa fa-times calendar-more",
              "aria-hidden": "true",
              onClick: togglePane
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workouts), (workout, index) => {
              return (_openBlock(), _createBlock(CalendarWorkout, {
                key: index,
                workout: workout,
                sportLabel: _unref(getSportLabel)(workout, _unref(sports))
              }, null, 8, ["workout", "sportLabel"]))
            }), 128))
          ], 512), [
            [_directive_click_outside, togglePane]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})